import { render, staticRenderFns } from "./MarginKpiStatusIndicator.vue?vue&type=template&id=44b57dc0&"
import script from "./MarginKpiStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./MarginKpiStatusIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports